import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import moment from 'moment';
import { capitalize } from 'lodash';

export const ReportsListNewElements = observer(() => {
    const { reduxReportState, reduxAction } = useAppStateContext();
    const { reportsListId, reports, reportsDownloadOptions } = reduxReportState;

    const getDocument = (
        event: React.MouseEvent<HTMLElement>,
        reportId: string,
        format: string,
        accountId: string | null
    ): void => {
        event.preventDefault();

        const report = reports?.items[reportId] ?? null;

        const startDate = report?.metadata.startDate;
        const endDate = report?.metadata.endDate;

        const from = startDate === null ? 'Invalid_date' : moment(startDate).format('YYYY-MM-DD');
        const to = endDate === null ? 'Invalid_date' : moment(endDate).format('YYYY-MM-DD');

        const accountIdTitle = accountId === null ? '' : `_${accountId}`;
        const title = `${report?.type ?? report?.type}_from_${from}_to_${to + accountIdTitle}`;

        reduxAction.onGetDocumentReport(reportId, title, format);
    };

    const elements = reportsListId.map((id) => {
        const report = reports?.items[id] ?? null;
        const accountId = reports?.collections.reports.accountId ?? null;
        const metaData = report?.metadata;
        const url = report?.versions.pdf?.url ?? report?.versions.html?.url;
        const CSVurl = report?.versions.csv?.url ?? null;

        let createdAt = report?.createdAt ?? null;

        if (createdAt === null) {
            createdAt = '—';
        } else {
            createdAt = moment(createdAt).format('D MMMM YYYY HH:mm');
        }

        let startDate, endDate;
        let range = '—';

        if (report === null) {
            return null;
        }

        switch (report.type) {
            case 'active-accounts':
                startDate = metaData?.lastBetAfter;
                endDate = report.createdAt;
                break;
            case 'card-expiration':
                startDate = metaData?.expiresAfter;
                endDate = metaData?.expiresBefore;
                break;
            default:
                startDate = metaData?.startDate;
                endDate = metaData?.endDate;
                break;
        }

        // cover doppler ISONIS reports
        if (report.template === 'isonis-report') {
            startDate = metaData?.from;
            endDate = metaData?.to;
        }

        const startDateValue = startDate ?? null;
        const endDateValue = endDate ?? null;

        if (startDateValue !== null && endDateValue !== null) {
            range = [moment(startDateValue).format('D MMMM YYYY'), moment(endDateValue).format('D MMMM YYYY')].join(
                ' – '
            );
        }

        return (
            <tr key={id}>
                <td>{createdAt}</td>
                <td>{range}</td>
                <td>{capitalize(report.status)}</td>
                {url === undefined ? (
                    <td />
                ) : (
                    <td className='buttons'>
                        {reportsDownloadOptions.includes('View') ? (
                            <a
                                className='btn'
                                href='#'
                                onClick={(): void => reduxReportState.openViewer(url)}
                            >
                                View
                            </a>
                        ) : null}
                        {reportsDownloadOptions.includes('Download') ? (
                            <a
                                className='btn'
                                href={url}
                                target='_blank'
                                rel='noreferrer'
                            >
                                Download
                            </a>
                        ) : null}
                        {reportsDownloadOptions.includes('Export to CSV') && CSVurl !== null ? (
                            <a
                                className='btn'
                                href='#'
                                onClick={(event): void => getDocument(event, id, 'csv', accountId)}
                            >
                                Export to CSV
                            </a>
                        ) : null}
                        {report.type === 'statements' ? (
                            <a
                                className='btn'
                                href='#'
                                onClick={(): void => reduxAction.onEmailReport(report.id, report.type)}
                            >
                                Email
                            </a>
                        ) : null}
                    </td>
                )}
            </tr>
        );
    });

    return <tbody>{elements}</tbody>;
});
